/**
 * CalfHealth-specific enumerations and constants
 */

export const CALF_LIFECYCLE_STAGES = {
  BIRTH_ARRIVAL: 'birth-arrival',
  COLOSTRUM: 'colostrum',
  MILK_PHASE: 'milk-phase',
  TRANSITION: 'transition',
  WEANING: 'weaning',
  REARING: 'rearing',
  FATTENING: 'fattening',
  BREEDING: 'breeding',
};

export const CALF_LIFECYCLE_STAGE_ORDER = [
  CALF_LIFECYCLE_STAGES.BIRTH_ARRIVAL,
  CALF_LIFECYCLE_STAGES.COLOSTRUM,
  CALF_LIFECYCLE_STAGES.MILK_PHASE,
  CALF_LIFECYCLE_STAGES.TRANSITION,
  CALF_LIFECYCLE_STAGES.WEANING,
  CALF_LIFECYCLE_STAGES.REARING,
  CALF_LIFECYCLE_STAGES.FATTENING,
  CALF_LIFECYCLE_STAGES.BREEDING,
];

export const CALF_DISEASE_CATEGORIES = {
  SCOURS: 'scours',
  BRD: 'brd',                     // Bovine Respiratory Disease
  NAVEL_INFECTION: 'navel-infection',
  JOINT_ILL: 'joint-ill',
  BLOAT: 'bloat',
  RINGWORM: 'ringworm',
  PNEUMONIA: 'pneumonia',
  OTHER: 'other',
};

export const VACCINATION_ROUTES = {
  SUBCUTANEOUS: 'subcutaneous',
  INTRAMUSCULAR: 'intramuscular',
  INTRANASAL: 'intranasal',
  ORAL: 'oral',
  INTRAVENOUS: 'intravenous',
};

/** California Faecal Scoring System (0–3) */
export const FAECAL_SCORES = {
  0: { label: 'Normal', description: 'Firm, well-formed' },
  1: { label: 'Semi-formed', description: 'Pasty, semi-formed' },
  2: { label: 'Loose', description: 'Runny, spreads easily' },
  3: { label: 'Watery', description: 'Liquid, severe diarrhoea' },
};

/** Wisconsin Calf Health Scoring System (0–3 per category) */
export const WISCONSIN_SCORE_CATEGORIES = {
  EYES: 'eyes',
  EARS: 'ears',
  NASAL: 'nasal',
  COUGH: 'cough',
};

export const WISCONSIN_SCORE_LABELS = {
  0: 'Normal',
  1: 'Mild',
  2: 'Moderate',
  3: 'Severe',
};

/** Calf-relevant diagnoses for general health events */
export const CALF_DIAGNOSE_VALUES = [
  'scours',
  'brd',
  'pneumonia',
  'navel_infection',
  'joint_ill',
  'bloat',
  'ringworm',
  'coccidiosis',
  'cryptosporidiosis',
  'rotavirus',
  'coronavirus',
  'e_coli',
  'salmonella',
  'clostridial',
  'dehydration',
  'acidosis',
  'selenium_deficiency',
  'vitamin_e_deficiency',
  'fracture',
  'hernia',
  'other',
];

export const DISEASE_SEVERITY = {
  MILD: 'mild',
  MODERATE: 'moderate',
  SEVERE: 'severe',
  CRITICAL: 'critical',
};

export const DISEASE_OUTCOME = {
  RECOVERED: 'recovered',
  ONGOING: 'ongoing',
  CHRONIC: 'chronic',
  DECEASED: 'deceased',
  CULLED: 'culled',
};

export const WEIGHT_METHODS = {
  SCALE: 'scale',
  TAPE: 'tape',          // weigh tape estimate
  ESTIMATED: 'estimated',
};
